module.exports = __webpack_public_path__ + "img/icon_shield_loop.9358b8bf.gif";